import React from 'react'
import '../../v2/PhoneNumberForm/LineNumber/index.scss'
import { get, useFormContext, useFormState } from 'react-hook-form'
import FieldErrorSectionForm from '@App/kit/fields/FieldErrorSectionForm'
import clsx from 'clsx'
import { FormFieldProps } from '@App/forms/common/form-field'

const LineNumber = (props: FormFieldProps) => {
    const formState = useFormState()
    const { register } = useFormContext()
    const { name, registerOptions, assistiveTextFunction } = props

    const error = get(formState.errors, name)
    const innerClassNames = clsx('input-text-form-component', 'main-color-set', error && 'error')
    const required = !!registerOptions && !!registerOptions.required
    const assistiveText = assistiveTextFunction ? assistiveTextFunction(required) : ''
    return (
        <div className="input-line-number" data-testid={name}>
            <div className={innerClassNames}>
                <label htmlFor={name} />
                <input {...register(name, registerOptions)} />
                <FieldErrorSectionForm name={name} assistiveText={assistiveText} required={required} />
            </div>
        </div>
    )
}

export default LineNumber
